import { useMutation } from '@tanstack/react-query'
import { transferListing, activeBulkProperties, deleteBulkProperties } from "./api"

export const useTransferListing = () => {
  return useMutation({
    queryKey: ['transfer-listing'],
    mutationFn: ({slug, payload}) => transferListing(slug, payload),
  })
}

export const useActiveBulkProperties = () => {
  return useMutation({
    mutationKey: ['active-bulk-properties'],
    mutationFn: (payload) => activeBulkProperties(payload),
  })
}

export const useDeleteBulkProperties = () => {
  return useMutation({
    mutationKey: ['delete-bulk-properties'],
    mutationFn: (payload) => deleteBulkProperties(payload),
  })
}